// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pAS6","col":"styles_col__2Q_BM","actions":"styles_actions__3CXdQ","conflict":"styles_conflict__3eDGo"};